import * as React from "react";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

export interface ISelectInputItem {
  group: string;
  value: string;
  label: string;
}

export const SelectInputCell = ({
  value,
  options,
  saveHandler,
  placeholder,
  className,
  key,
}: {
  value: string | undefined;
  options: ISelectInputItem[];
  key: string;
  placeholder: string;
  saveHandler: (value: string) => Promise<any>;
  className?: string;
}) => {
  const groups = groupByGroup(options);

  const onBlur = async (v: string) => {
    await saveHandler(v);
  };

  return (
    <Select
      key={key}
      defaultValue={options.find((option) => option.value === value)?.value}
      onValueChange={(v) => onBlur(v)}
    >
      <SelectTrigger
        style={{ border: "none", outline: "none", boxShadow: "none" }}
        className={cn("border-none bg-transparent", className)}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {groups.map((group, index) => (
          <SelectGroup key={index.toString()}>
            <SelectLabel>{group?.[0]?.group}</SelectLabel>
            {group.map((item) => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
};

function groupByGroup(items: ISelectInputItem[]): ISelectInputItem[][] {
  const groupedItems: { [key: string]: ISelectInputItem[] } = {};

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (!groupedItems[item.group]) {
      groupedItems[item.group] = [];
    }
    groupedItems[item.group].push(item);
  }

  return Object.values(groupedItems);
}
